export const SupportedImageFileTypes = ['jpg', 'jpeg', 'png', 'bmp', 'webp', 'dib'];
export const SupportedImageFileTypesString = SupportedImageFileTypes.map(fileType => '.' + fileType).join(',');
export const NoImageCitySrc = require('../images/no-image-city.jpg');
export const NoImageCardSrc = require('../images/no-image-card.png');